import { useTranslation } from 'react-i18next';
import Header from '../../components/special/Header';
import ExoContractPreset from '../../components/exo/ExoContractPreset';

const RecurringInvoicePresets = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header title={t('Recurring Invoice Templates')} />
      <ExoContractPreset type="recurringInvoice" />
    </>
  );
};

export default RecurringInvoicePresets;
